import { render, staticRenderFns } from "./BaseItemCompetitionIconPhoto.vue?vue&type=template&id=54a5bf0e&scoped=true&"
import script from "./BaseItemCompetitionIconPhoto.vue?vue&type=script&lang=js&"
export * from "./BaseItemCompetitionIconPhoto.vue?vue&type=script&lang=js&"
import style0 from "./BaseItemCompetitionIconPhoto.vue?vue&type=style&index=0&id=54a5bf0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a5bf0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54a5bf0e')) {
      api.createRecord('54a5bf0e', component.options)
    } else {
      api.reload('54a5bf0e', component.options)
    }
    module.hot.accept("./BaseItemCompetitionIconPhoto.vue?vue&type=template&id=54a5bf0e&scoped=true&", function () {
      api.rerender('54a5bf0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseItemCompetitionIconPhoto.vue"
export default component.exports